import {Component, Input} from "@angular/core";
import {NgStyle} from "@angular/common";

@Component({
  selector: 'app-dashboard-annual-section',
  templateUrl: './dashboard-annual-section.component.html',
  standalone: true,
  imports: [
    NgStyle
  ],
  styleUrl: './dashboard-annual-section.component.css'
})

export class DashboardAnnualSectionComponent{
  @Input() title!: string;
  @Input() value!: string | number;
  @Input() subtitle!: string;
  @Input() icon!: string;
  @Input() iconColor!: string;
  @Input() iconBg!: string;
  @Input() borderColor!: string;
}
